import React, { useState, useEffect } from 'react';
import { Upload, Icon, message, Button, Input } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import styles from './multipleVideoUpload.module.scss'
import * as apis from '@/apis'

const VideoUpload = (props) => {
  const { value, onChange = () => { }, onFileChange = () => { } } = props
  const [loading, setLoading] = useState(false);

  const emitData = (list) => {
    onChange(list);
    onFileChange(list);
  }
  // 处理文件上传
  const handleChange = ({ fileList }) => {
    console.log('fileList',fileList)
    // 智能过滤：保留已上传成功的文件，只过滤新上传不符合条件的文件
    const filteredFileList = fileList.filter(file => {
      // 已成功上传的文件（有response）直接保留
      if (file.response) {
        return true;
      }
      
      // 只检查没有response的文件（新上传文件）
      const fileObj = file.originFileObj || file;
      // 检查文件类型
      const isVideo = fileObj.type && fileObj.type.includes('video');
      
      // 检查文件大小
      const MAX_FILE_SIZE = 200 * 1024 * 1024; // 200MB
      const isLt200M = fileObj.size && fileObj.size <= MAX_FILE_SIZE;
      
      // 只保留视频文件且大小不超过200MB的文件
      return isVideo && isLt200M;
    });
    
    emitData(filteredFileList);
  };

  // 自定义上传行为
  const customRequest = async ({ file, onSuccess }) => {

    setLoading(true); // 开始上传时显示Loading
    const formData = new FormData()
    formData.append('file', file)
    formData.append('type', 'product-files')

    try {
      const response = await apis.uploadFile(formData)

      onSuccess({
        id: Math.random().toString(36).slice(-8),
        url: response.url,
        name: file.name?.split('.')[0] || '',
      }, file);
    } catch (error) {
      message.error('上传失败：' + (error.message || '未知错误'));
    } finally {
      setLoading(false); // 无论成功或失败，都结束Loading状态
    }
  };

  // 上传前的校验
  const beforeUpload = file => {
    const isVideo = file.type.includes('video');
    if (!isVideo) {
      message.error('只能上传视频文件!');
      return false
    }
    const MAX_FILE_SIZE = 200 * 1024 * 1024;
    const isLt200M = file.size <= MAX_FILE_SIZE;
    if (!isLt200M) {
      message.error('文件大小不能超过 200MB!');
      return false
    }
    return isVideo && isLt200M;
  };

  const onRemoveHandler = id => {
    const files = value?.filter(item => item?.response.id !== id);
    emitData(files)
  }

  return (
    <div className={styles.uploadwrap}>
      {
        value?.map((item, index) => (
          <div key={item.uid} className={styles.item}>
            <div className={styles.imgcontent}>
              <div className={styles.img}>
                <Icon type="file" theme="twoTone" style={{ fontSize: '26px' }} />
              </div>
              <div className={styles.overlay}>
                <span className={styles.delBtn} onClick={() => {
                  onRemoveHandler(item?.response?.id)
                }}>
                  <DeleteOutlined style={{ color: "#ffffff", fontSize: "20px" }} />
                </span>

                <span className={styles.delBtn} onClick={() => {
                  window.open(item?.response?.url)
                }}>
                  <Icon type="eye" style={{ color: "#ffffff", fontSize: "20px" }} />
                </span>
              </div>
            </div>

            <Input value={item?.response?.name} onChange={(e) => {
              emitData(value.map(v => {
                if (v?.response?.id === item?.response?.id) {
                  v.response.name = e.target.value
                }
                return v
              }))
            }} />
          </div>
        ))
      }
      <div>
        <Upload
          fileList={value}
          onChange={handleChange}
          customRequest={customRequest}
          beforeUpload={beforeUpload}
          listType="picture-card"
          accept="video/*"
          multiple
          showUploadList={false}
          disabled={loading}
        >
          <div>
            {loading ? <Icon type="loading" /> : <Icon type="upload" />}
            <div>{loading ? '上传中...' : '上传视频'}</div>
          </div>
        </Upload>
      </div>
    </div>
  );
};

export default VideoUpload;